var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailOpenLine = function SvgMailOpenLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3.719 7.369 8.322-4.99a.9.9 0 0 1 .926 0l8.314 4.99a.45.45 0 0 1 .219.387V19.2a.9.9 0 0 1-.9.9H4.4a.9.9 0 0 1-.9-.9V7.755a.45.45 0 0 1 .219-.386M5.3 8.519V18.3h14.4V8.52L12.504 4.2zm7.254 5.01 4.766-4.017 1.16 1.377-5.913 4.983-6.04-4.977 1.145-1.39 4.882 4.023Z"
  })));
};
export default SvgMailOpenLine;